export const columnDefs = (t: (key: string) => string) => [
    {
        key: 'name',
        title: t('portfolio.createNewPortfolio.productName'),
    },
    {
        key: 'allocation',
        title: t('portfolio.createNewPortfolio.instrumentAllocation'),
    },
];

export const nextReallocationColumnDefs = (t: (key: string) => string, formatDate: (date: string) => string) => [
    {
        key: 'date',
        title: t('shadowAccount.transactions.date'),
        render: (val: string) => formatDate(val),
    },
    {
        key: 'strategyName',
        title: t('clientDashboard.portfolio.strategy'),
    },
];
